module.exports = __webpack_public_path__ + "img/lens.6c072bed.png";